import clsx from "clsx"
import React, { type HTMLAttributes } from "react"

interface ICollapseProps extends HTMLAttributes<HTMLDivElement> {
  in: boolean
}

export class Collapse extends React.Component<ICollapseProps> {
  private wrapperRef = React.createRef<HTMLDivElement>()
  private objserver: MutationObserver | null = null
  // No need this
  // constructor(props: ICollapseProps) {
  //   super(props)
  // }
  updateHeight = () => {
    const wrapper = this.wrapperRef.current
    if (wrapper == null) return
    wrapper.style.height = (this.props.in == null ? true : this.props.in) ? `${wrapper.scrollHeight}px` : "0px"
  }

  componentDidMount(): void {
    const wrapper = this.wrapperRef.current
    if (wrapper == null) return
    this.updateHeight()
    this.objserver = new MutationObserver(() => {
      setTimeout(this.updateHeight, 0)
    })
    this.objserver.observe(wrapper, { childList: true, subtree: true })
  }

  componentWillUnmount(): void {
    if (this.objserver) this.objserver.disconnect()
  }

  componentDidUpdate(prevProps: Readonly<ICollapseProps>): void {
    if (prevProps.in !== this.props.in) {
      this.updateHeight()
    }
  }

  render() {
    return (
      <div className={clsx("custom-collapse h-0 overflow-hidden duration-300 ease-in-out", this.props.className)} ref={this.wrapperRef}>
        {this.props.children}
      </div>
    )
  }
}
